import React, { useEffect,useRef, } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import { CircularProgress, TextField } from "@mui/material";
import { LOCAL_STORAGE } from "Components/Constants/LocalStorage";

export default function Asynchronous(props, ref) {
  const { getOptionLabel, Service, value, inputProps, variant,
    onChange, searchBy,withoutLocationFilter,freeVocuher, ...rest } =
    props;
  
  const localRef = useRef(null);
  const inputRef = ref || localRef;
  const [inputValue, setInputValue] = React.useState("");
  const [options, setOptions] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);

  let locationCode = JSON.parse(localStorage.getItem(LOCAL_STORAGE.BIZX_LOCATION)).code;


   const handleInputValueChange = (e, newValue) => {
    if (newValue.length === 1 && newValue === "A") {
      setLoading(false);
      setInputValue("");
      return;
    }
    setInputValue(newValue);
  };
  
   useEffect(() => {
    let isActive = true;

    const fetchOptions = async () => {
      if (inputValue.length >= 3 && inputValue.length <= 12) {
        setLoading(true);
        try {
          const response = await Service(inputValue);
          if (!isActive) return;

          setOptions(response);
          setLoading(false);

          // Auto-select if only one option is available
          if (response.length === 1) {
            onChange?.(null, response[0]);
            setInputValue(
              getOptionLabel
                ? getOptionLabel(response[0])
                : response[0].name + " | " + response[0].barcode
            );
          }
        } catch (error) {
          if (isActive) {
            console.error("Autocomplete service error:", error);
            setLoading(false);
          }
        }
      } else {
        setOptions([]);
        setLoading(false);
      }
    };

    if (inputValue && inputValue !== "A") {
      fetchOptions();
    } else {
      setOptions([]);
    }

    return () => {
      isActive = false;
    };
  }, [inputValue, Service, getOptionLabel, onChange]);

  useEffect(() => {
    open && options.length === 0 && setLoading(true);
  }, [open, options.length]);

  return (
    <Autocomplete
      autoHighlight
      open={open}
      onClose={() => {
        setOpen(false);
      }}
      onOpen={() => {
        setOpen(true);
      }}
//       onChange={(e, newValue) => {
//   if (newValue && newValue.remainingQuantity <= 0) {
//     alert("Cannot select item with zero stock!");
//     return;
//   }
//   if (props.onChange) props.onChange(e, newValue);
// }}
      clearOnEscape
      value={value === "" ? null : value}
      getOptionLabel={
        getOptionLabel
          ? getOptionLabel
          : (option) => option.name + " | " + option.barcode
      }
      {...rest}
      options={options}
      loading={loading}
      inputValue={inputValue}
      onInputChange={handleInputValueChange}
      onChange={onChange}
      renderInput={(params) => (
        <TextField
          {...params}
          {...inputProps}
          variant={variant ? variant : "outlined"}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <React.Fragment>
                {loading && open ? (
                  <CircularProgress color="inherit" size={15} />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
}